import { render, staticRenderFns } from "./orderTracking.vue?vue&type=template&id=48ba5378"
import script from "./orderTracking.vue?vue&type=script&lang=js"
export * from "./orderTracking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports